import { useState, useEffect } from "react";
import { not_available_horizontal, not_available_vertical } from "../../pngs";
import { getImg, privGtmKey } from "../../utils";
import { sendTag, event_properties_101_06 } from "../CoalitionGtm";
import "./CoalitionBanner.scss";

export const CoalitionBanner = ({ item }) => {
  const gtm = localStorage.getItem(privGtmKey);
  const goToBannerUrl = (name) => {
    if (gtm) {
      let payload = event_properties_101_06();
      payload.promo_id = name;
      sendTag(gtm, payload);
    }
  };

  const { url, desktop_image, mobile_image, offer_name } = item;
  const [imgDesktop, solveDesktop] = useState();
  const [imgMobile, solveMobile] = useState();

  useEffect(() => {
    const testImgDesktop = (url) => {
      const klass = "img desktop";
      let i = new Image();
      i.onload = () => solveDesktop(getImg(url, klass));
      i.onerror = () => solveDesktop(getImg(not_available_horizontal, klass));
      i.src = url;
    };
    const testImgMobile = (url) => {
      const klass = "img mobile";
      let i = new Image();
      i.onload = () => solveMobile(getImg(url, klass));
      i.onerror = () => solveMobile(getImg(not_available_vertical, klass));
      i.src = url;
    };
    testImgDesktop(desktop_image);
    testImgMobile(mobile_image);
  }, [item, desktop_image, mobile_image]);

  const regex1 = /^https?:\/\/www\./gi;
  const regex2 = /^https?:\/\//gi;
  let fixedUrlDestiny;
  if (url && !url.match(regex1)) {
    fixedUrlDestiny = url.replace(regex2, "https://www.");
  } else {
    fixedUrlDestiny = url;
  }

  return (
    <div
      className="banner"
      onClick={() => goToBannerUrl(offer_name)}
      onKeyPress={() => goToBannerUrl(offer_name)}
      role="button"
      tabIndex={0}
    >
      <a
        href={fixedUrlDestiny}
        target="_blank"
        rel="noopener noreferrer"
        className="link"
      >
        {imgDesktop}
        {imgMobile}
      </a>
    </div>
  );
};
